import ABSScrollbars from '@abs/core/ABSScrollbars';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import clsx from 'clsx';
import { memo } from 'react';
import Logo from '../../../../shared-components/Logo';
import NavbarToggleButton from '../../../../shared-components/NavbarToggleButton';
import Navigation from '../../../../shared-components/Navigation';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/styles';
import { Hidden, Typography } from '@mui/material';
import UserNavbarHeaderNew from 'app/theme-layouts/shared-components/UserNavbarHeaderNew';

const Root = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  '& ::-webkit-scrollbar-thumb': {
    boxShadow: `inset 0 0 0 20px ${
      theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.24)' : 'rgba(255, 255, 255, 0.24)'
    }`,
  },
  '& ::-webkit-scrollbar-thumb:active': {
    boxShadow: `inset 0 0 0 20px ${
      theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.37)' : 'rgba(255, 255, 255, 0.37)'
    }`,
  },
}));

const StyledContent = styled(ABSScrollbars)(({ theme }) => ({
  overscrollBehavior: 'contain',
  overflowX: 'hidden',
  overflowY: 'auto',
  WebkitOverflowScrolling: 'touch',
  // background:
    // 'linear-gradient(rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0) 30%), linear-gradient(rgba(0, 0, 0, 0.25) 0, rgba(0, 0, 0, 0) 40%)',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100% 40px, 100% 10px',
  backgroundAttachment: 'local, scroll',
}));

function NavbarStyle2Content(props) {
  const theme = useTheme();
	const user = useSelector(({ user }) => user);

  return (
    <Root className={clsx('flex flex-auto flex-col overflow-hidden h-full', props.className)}>
      <AppBar
        color="primary"
        position="static"
        className="flex flex-row items-center shrink h-48 md:h-76 min-h-48 md:min-h-76 px-12 shadow-0 logowrapper"
      >
        <div className="flex flex-1 mx-4">
          <Hidden lgUp>
              {theme.palette.mode == "dark" ?
              <Logo type="short" imgClassName="h-48"/>
              :
              <Logo type="short" colorname="white" imgClassName="h-48"/>
              }
            </Hidden>
            <Hidden lgDown>
            <Typography className="text-16 leading-none font-medium logo-text">
              {user.CompanyName}
            </Typography>
					</Hidden>
        </div>

        <NavbarToggleButton className="w-40 h-40 p-0" />
      </AppBar>

      <UserNavbarHeaderNew className="userwrapper"/>

      <StyledContent option={{ suppressScrollX: true, wheelPropagation: false }} className='mt-28 contentwrapper'>
        <Navigation layout="vertical" className="-mt-32"/>
      </StyledContent>
    </Root>
  );
}

export default memo(NavbarStyle2Content);
